import React from 'react';
import { useSelector } from 'react-redux';

const NotFound = () => {
    const { i18n } = useSelector(state => state.someFun);
    return (
        <div className='h-screen'>
            <div className='container mx-auto p-5'>
                <h2 className='text-bnd-1 font-extrabold text-6xl font-poppins'>{i18n === 'en' ? "Ooops!" : 'আহা!'}</h2>
                <h5 className='text-bnd-1 font-extrabold text-3xl font-poppins'>{i18n === 'en' ? "404 - PAGE NOT FOUND" : '404 - এই পেইজ টি পাওয়া যায় নি।'}</h5>
                <br />
                {i18n === 'en' ?
                    <p className='text-bnd-1 font-semibold font-poppins text-lg'>
                        The page you are looking for might have been removed <br />
                        had its name changed or is temporarily unavailable.
                    </p>
                    :
                    <p>
                        আপনি যে পৃষ্ঠাটি খুঁজছেন সেটির নাম পরিবর্তিত হলে বা সাময়িকভাবে অনুপলব্ধ হলে সেটি সরিয়ে ফেলা হতে পারে ।
                    </p>
                }

            </div>
        </div>
    );
};

export default NotFound;